export const getNestedValue = (object, compositeKey) => {
  const keys = compositeKey.split('.');
  let value = object;
  for (const key of keys) {
    value = value?.[key];
    if (!value) return undefined;
  }
  return value;
};
